import styled from "@emotion/styled";
import DownIcon from "../../../img/Down.svg?react";

interface AccordionDownIconProps {
  isAccordionOpen: boolean;
}

export const AccordionDownIcon = styled(DownIcon, {
  shouldForwardProp: propName => propName !== "isAccordionOpen",
})<AccordionDownIconProps>`
  transform: ${props => (props.isAccordionOpen ? "rotate(-180deg)" : "none")};
  transition: transform 0.1s;
  color: ${props => props.color ?? props.theme.font.secondary.default};
  path {
    stroke-width: ${props => props.strokeWidth ?? 2}px;
  }
`;
